@use "variables" as *;

.mainDiv {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.container {
  padding: $spacing-s calc(#{$spacing-s} + #{$spacing-m}) !important;
  display: flex !important;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.collapse {
  width: 100%;
}

.title {
  font-size: $fontSize-m;
  font-weight: normal;
  padding-top: 6px;
  margin-bottom: 0 !important;
  align-self: flex-start;
}

.loadingDiv {
  padding-top: $spacing-s;
  padding-left: $spacing-m;
  width: 32px;
  height: 32px;
}

.insightsStack {
  margin: 0 $spacing-l $spacing-xl $spacing-l;
}

.insightTitle {
  margin-left: $spacing-xxs !important;
  font-size: $fontSize-m;
  white-space: pre-wrap;
}

.insightText {
  margin-top: $spacing-xs !important;
  font-size: $fontSize-xs;
  white-space: pre-wrap;
}

.insightDate {
  text-align: right;
  margin-top: $spacing-m !important;
  font-size: $fontSize-xxs;
  white-space: pre-wrap;
}

.priceCard {
  width: fit-content !important;
  padding: $spacing-s;
  margin: $spacing-xs 0 !important;
  border-radius: 16px !important;
}

.priceText {
  font-size: $fontSize-xs;
  white-space: pre-wrap;
}

.chips {
  margin: $spacing-m $spacing-xxs $spacing-xxs $spacing-xxs !important;
  padding: 0 !important;
}

.insightDisclaimer {
  margin-bottom: $spacing-xxs;
  font-size: $fontSize-xxs;
  font-weight: lighter;
  white-space: pre-wrap;
  width: 100%;
}

.refreshButton {
  position: absolute;
  height: auto !important;
  top: $spacing-m;
  right: $spacing-l;
  margin: 0;
}
